(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventPlace', EventPlace);

    EventPlace.$inject = ['$resource'];

    function EventPlace ($resource) {
        var resourceUrl =  'api/event-places/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
